import {showMore} from "./module/showmore";
import {getParam} from "./module/getParam";

// search_filter
//---------------------------------------------------------
function search_filter() {
	const tagList = '.js-tag-list';
	const item = '.js-tagItem-list li';
	const is_hidden = 'is-hidden';

	$(item).removeClass(is_hidden);
	for (let i = 0; i < $(tagList).length; i++) {
		const name = $(tagList).eq(i).find('input').attr('name');
		const searchData = get_selected_input_items(name);
		if(searchData.length === 0 || searchData[0] === '') {
			continue;
		}
		for (let j = 0; j < $(item).length; j++) {
			const itemData = get_setting_values_in_item($(item).eq(j), name);
			const check = array_match_check(itemData, searchData);
			if (!check) {
				$(item).eq(j).addClass(is_hidden);
			}
		}
	}

	function get_selected_input_items(name) {
		const searchData = [];
		$('[name=' + name + ']:checked').each(function() {
			searchData.push($(this).val());
		});
		return searchData;
	}

	function get_setting_values_in_item(target, data) {
		let itemData = target.data(data);
		if (!Array.isArray(itemData)) {
			itemData = [itemData];
		}
		return itemData;
	}

	function array_match_check(arr1, arr2) {
		let arrCheck = false;
		for (let i = 0; i < arr1.length; i++) {
			if (arr2.indexOf(arr1[i]) >= 0) {
				arrCheck = true;
				break;
			}
		}
		return arrCheck;
	}
}

// outputParam
//---------------------------------------------------------
function outputParam() {
	const $tab =  $('.js-tab');
	const $tabPanel =  $('.js-tabPanel');
	const $innerTab =  $('.js-inner-tab');
	const $innerTabPanel =  $('.js-inner-tabPanel');
	const is_current = 'is-current';

	let tabPram = ['hokkaido_tohoku','kanto','hokuriku_chubu','kinki','shikoku','chugoku','kyushu_okinawa'];
	let pram = getParam('region');

	if (pram && $.inArray(pram, tabPram) !== -1) {
		$('.js-tab, .js-tabPanel').removeClass(is_current);
		$tab.attr('aria-selected', false);
		$tabPanel.attr('aria-hidden', true);
		$('[data-tab="' + pram + '"]').addClass(is_current);
		$('.js-tab[data-tab="' + pram + '"]').attr('aria-selected', true);
		$('.js-tabPanel[data-tab="' + pram + '"]').attr('aria-hidden', false);
	}

	let innerTabPram = ['hokkaido','aomori','iwate','akita','miyagi','yamagata','fukushima','ibaraki','chiba','tochigi','gunma','saitama','tokyo','kanagawa','nigata','toyama','ishikawa','fukui','nagano','yamanashi','shizuoka','gifu','aichi','mie','shiga','kyoto','nara','osaka','wakayama','hyogo','kagawa','tokushima','ehime','kochi','tottori','okayama','shimane','hiroshima','yamaguchi','fukuoka','oita','miyazaki','kumamoto','kagoshima','saga','nagasaki','okinawa'];
	let innerPram = getParam('pref');

	if (innerPram && $.inArray(innerPram, innerTabPram) !== -1) {
		$('.js-inner-tab, .js-inner-tabPanel').removeClass(is_current);
		$innerTab.attr('aria-selected', false);
		$innerTabPanel.attr('aria-hidden', true);
		$('[data-tab="' + innerPram + '"]').addClass(is_current);
		$('.js-inner-tab[data-tab="' + innerPram + '"]').attr('aria-selected', true);
		$('.js-inner-tabPanel[data-tab="' + innerPram + '"]').attr('aria-hidden', false);
	}

	let faqTabPram = ['after_service','product','buy','other'];
	let faqPram = getParam('faq');
	if (faqPram && $.inArray(faqPram, faqTabPram) !== -1) {
		$('.js-tab, .js-tabPanel').removeClass(is_current);
		$tab.attr('aria-selected', false);
		$tabPanel.attr('aria-hidden', true);
		$('[data-tab="' + faqPram + '"]').addClass(is_current);
		$('.js-tab[data-tab="' + faqPram + '"]').attr('aria-selected', true);
		$('.js-tabPanel[data-tab="' + faqPram + '"]').attr('aria-hidden', false);
	}

	function tabChange() {
		$('.js-inner-tab, .js-inner-tabPanel').removeClass(is_current);
		$('.js-inner-tab[aria-selected="true"]').attr({'aria-selected':false});
		$('.js-inner-tabPanel[aria-hidden="false"]').attr({'aria-hidden':true});

		$('.js-tabPanel[data-tab="' + pram + '"]').find('ul > li:nth-child(1) .js-inner-tab').addClass(is_current);
		$('.js-tabPanel[data-tab="' + pram + '"]').find('ul > li:nth-child(1) .js-inner-tab').attr({'aria-selected':true});
		$('.js-tabPanel[data-tab="' + pram + '"]').find('.js-inner-tabPanel:nth-child(1)').addClass(is_current);
		$('.js-tabPanel[data-tab="' + pram + '"]').find('.js-inner-tabPanel:nth-child(1)').attr('aria-hidden', false);
	}

	if(location.search == '?region=hokkaido_tohoku') {
		tabChange()
	}
	if(location.search == '?region=kanto') {
		tabChange()
	}
	if(location.search == '?region=hokuriku_chubu') {
		tabChange()
	}
	if(location.search == '?region=kinki') {
		tabChange()
	}
	if(location.search == '?region=shikoku') {
		tabChange()
	}
	if(location.search == '?region=chugoku') {
		tabChange()
	}
	if(location.search == '?region=kyushu_okinawa') {
		tabChange()
	}

	if(location.search == '?faq=after_service') {
		tabChange()
	}
	if(location.search == '?faq=product') {
		tabChange()
	}
	if(location.search == '?faq=buy') {
		tabChange()
	}
	if(location.search == '?faq=other') {
		tabChange()
	}
}

function moreBtn() {
	const $more = $('.page-support-tag__more');
	const $moreBtn = $('.page-support-tag__more-btn');
	const $tagList = $('.page-support-tag__list');

	$more.on('click', function() {
		$(this).toggleClass('is-open');
		$tagList.toggleClass('is-open');

		if($(this).hasClass('is-open')) {
			$moreBtn.text('一部表示');
		}else {
			$moreBtn.text('もっと見る');
		}
	});
}

//init
//---------------------------------------------------------
$(function(){
	$(document).on('change', $('.js-tag-list input'), function() {
		search_filter();
		$('.page-support-column-content .js-showMore').hide();

		if(!$('.js-tag-list input').is(':checked')) {
			$('.page-support-column-content .js-showMore').show();
			showMore('.js-show-contents', 12);
		}
	});

	moreBtn();
	showMore('.js-show-contents', 12);
	outputParam();
});
